import {useTranslation} from "react-i18next";
import {Stack, Typography} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

export interface Props {
    errorMessage: string | undefined;
}

export const ErrorViewLayout: React.FC<Props> = ({errorMessage}) => {
    const {t} = useTranslation();

    return (
        <Stack direction="column" paddingX="3rem" paddingTop="3rem" paddingBottom="0.5rem" gap="2.25rem">
            <Stack direction="row" alignItems="center" gap="1.125rem">
                <ErrorIcon
                    sx={{
                        height: 36,
                        width: 36,
                    }}
                    color="error"
                />
                <Typography fontSize={30} lineHeight={1.27} fontWeight={700}>
                    {t("main_view_layout.error")}
                </Typography>
            </Stack>
            <Typography fontSize={16}>{errorMessage}</Typography>
        </Stack>
    );
};
